import styled, { css } from "styled-components";
import React from "react";

export interface SkeletonProps extends React.HTMLAttributes<HTMLDivElement> {
    loading?: boolean;
    width?: string | number;
    height?: string | number;
    css?: any;
}

const SkeletonRoot = styled.div<SkeletonProps>`
    ${({ width }) =>
        width &&
        css`
            width: ${typeof width === "number" ? `${width}px` : width};
        `}
    ${({ height }) =>
        height &&
        css`
            height: ${typeof height === "number" ? `${height}px` : height};
        `}
    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
    background-size: 200% 100%;
    animation: loading 1.5s ease-in-out infinite;
    border-radius: 4px;

    @keyframes loading {
        0% {
            background-position: 200% 0;
        }
        100% {
            background-position: -200% 0;
        }
    }
`;

const Skeleton: React.FC<SkeletonProps> = ({ loading = true, children, ...props }) => {
    if (!loading) {
        return <>{children}</>;
    }

    return <SkeletonRoot {...props}>{children}</SkeletonRoot>;
};

export default Skeleton;


